<template>
  <div class="sign-up">
    <v-container fluid>
      <h2 class="mb-3">Create a new account</h2>

      <v-card color="cardgray">
        <v-container>
          <v-form
              v-model="valid"
              ref="form"
              lazy-validation
            >
            <v-text-field
              name="email"
              label="Email"
              v-model="email"
              :rules="emailRules"
              type="text"
              required
            ></v-text-field>

            <v-text-field
              name="password"
              label="Password"
              v-model="password"
              :rules="passwordRules"
              required
              type="password"
            ></v-text-field>

            <v-text-field
              name="confirmPassword"
              label="Confirm password"
              v-model="confirmPassword"
              :rules="confirmPasswordRules"
              required
              type="password"
            ></v-text-field>

            <v-text-field
              name="displayName"
              label="Public display name"
              v-model="displayName"
              :rules="displayNameRules"
              required
              type="text"
            ></v-text-field>

            <v-btn
              @click="signUp"
              :disabled="!valid"
              color="primary"
            >
              Submit
            </v-btn>
            <v-btn @click="clear">clear</v-btn>

          </v-form>
        </v-container>

        <v-container>
          <h4 v-if='errorMessage' style="color:#ed831a;" class="mt-1 mb-1">Error: {{ errorMessage }}</h4>
          <!-- <p> Don't have an account yet? You can <router-link to="/signup">create one.</router-link></p> -->
          <v-divider></v-divider>
          <h4 class='mt-3'>Already have an account?<v-btn flat color="primary" to="login">Login</v-btn></h4>
          <h4 class='mb-1'>Forgot your password?<v-btn flat color="primary" to="forgot-password">Reset password</v-btn></h4>

        </v-container>
        
      </v-card>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'SignUp',
  data: function () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      displayName: '',
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /\S+@\S+\.\S+/.test(v) || 'E-mail must be valid' // anystring@anystring.anystring
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length > 5 || 'Password must be at least 6 characters'
      ],
      displayNameRules: [
        v => !!v || 'A public display name is required',
        v => v.length > 2 || 'Must be at least 3 characters'
      ],
      confirmPasswordRules: [
        (v) => !!v || 'Please re-type password to confirm',
        (v) => v === this.password || 'Passwords must match'
      ],
      errorMessage: null
    }
  },
  // computed: {
  //   comparePasswords () {
  //     return this.password !== this.confirmPassword ? 'Passwords do not match' : ''
  //   }
  // },
  methods: {
    logout: function () {
      firebase.auth().signOut()
      .then(() => {
        this.$router.replace('login')
        .then(() => {
          console.log('Signed out, goodbye.')
        })
      })
      .catch((err) => {
        console.log('Oops, something went wrong while logging out: ', err.message)
        this.$set(this.$data, 'errorMessage', err.message)
      })
    },
    signUp: function () {
      // returns a promise with `onResolve` and `onReject` callback
      firebase.auth().createUserWithEmailAndPassword(
        this.email, this.password
      )
      .then((user) => {
          // console.log(user)
        user.updateProfile({
          displayName: this.displayName,
          photoURL: 'https://robohash.org/' + this.email + '?size=120x120'
        })
        user.sendEmailVerification()
        .then((u) => {
          console.log('Email verification sent to: ' + u)
        })
        .then(() => {
          this.$router.push('verify-email')
        })
      },
      // catch errors
      (err) => {
        console.log('Oops, there was an error with account creation: ' + err.message)
        this.$set(this.$data, 'errorMessage', err.message)
      })

      // .then(logout())
      // .then(this.$router.push({path: 'login'}))
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
  .signUp {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 10px;
    width: 10%;
    cursor: pointer;
  }
  span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/SignUp.vue